import _ from 'lodash';
import {error} from '.';
import {fmsServerBase} from '../config/environment';
import overlayConfig from '../config/overlays';
import {fetchJson} from '../utils/fetch_utils';
import {urlParams} from '../utils/security_utils';
import * as ActionTypes from './actionTypes';

const HEADERS = {
  cache: 'no-cache',
  headers: {
    'Accept': 'application/json'
  }
};

export const populateFmsDataAsync = (kcToken) => {

  const overlay = _.keyBy(overlayConfig, 'id')['FMS'];

  if (!overlay) {
    return { type: 'DO_NOTHING' };
  }

  const { config } = overlay;
  const base = (overlay.config.base || fmsServerBase) + (overlay.config.baseSuffix || '');

  return dispatch => {
    if (!base || !config.listService) {
      dispatch(error('Call to get FMS data for overlay without list service configured.'));
      return;
    }

    if (kcToken) {
      HEADERS.headers.Authorization = 'Bearer ' + kcToken;
      fetchJson(_constructListServiceRequestString(base, config.listService), HEADERS)
      .then(data => _toGeoJson(data))
      .then(data => dispatch(_populateFmsData(data)))
      .catch(err => dispatch(error('Call to get FMS data failed: ' + (err.message || err))));
    } else {
      // TODO: This is just local development code because we don't get a kc token locally.
      const data = _tempData();
      const gjData = _toGeoJson(data);
      dispatch(_populateFmsData(gjData));
    }
  };
};

export const populateFmsDataForGraphAsyncPromise = (fms, data_idx) => {
  const overlay = _.keyBy(overlayConfig, 'id')['FMS'];

  if (!overlay) {
    return () => Promise.resolve();
  }

  const { config } = overlay;
  const base = (overlay.config.base || fmsServerBase) + (overlay.config.baseSuffix || '');

  return dispatch => {
    if (!base || !config.stationService) {
      dispatch(error('Call to get FMS data for overlay without station service configured.'));
      return Promise.resolve();
    }

    return fetchJson(_constructStationServiceRequestString(base,
        config.stationService,
        config.securityKey,
        fms.stationid),
      HEADERS)
    .then(data => dispatch(_populateFmsGraphData(data, data_idx)))
    .catch(e => {
      const msg = 'Call to get FMS data failed: ' + e.message;
      dispatch(error(msg));
    })
    .then(() => {});
  };
};

const _toGeoJson = (data) => {
  const geoJson = {};
  geoJson.type = 'FeatureCollection';
  geoJson.features = [];

  data.forEach((stationData) => {
    geoJson.features.push(_createFmsFeature(stationData));
  });

  return geoJson;
};

const _createFmsFeature = (data) => {
  const feature = {};
  feature.type = 'Feature';
  feature.properties = { ...data };
  feature.geometry = {
    type: 'Point',
    coordinates: [data.longitude, data.latitude]
  };

  delete feature.properties.longitude;
  delete feature.properties.latitude;

  return feature;
};

const _populateFmsData = (data) => {
  return {
    type: ActionTypes.POPULATE_FMS_DATA,
    data: data
  };
};

const _populateFmsGraphData = (data, data_idx) => {
  return {
    type: ActionTypes.POPULATE_FMS_GRAPH_DATA,
    data, data_idx
  };
};

const _constructListServiceRequestString = (base, service) => {
  return `${base}${service}`;
};

const _constructStationServiceRequestString = (base, service, securityKey, station_id) => {
  service = service.replace('{stationId}', station_id);
  return `${base}${service}?${urlParams(service, securityKey)}`;
};

const _tempData = () => {
  return [
    {
      'stationCode': 'BAMBRA',
      'name': 'Anglesea - Bambra-Aireys Inlet Road',
      'mgrs': '55HBT4018645371',
      'latitude': -38.40216604,
      'longitude': 144.0246844,
      'latestDataId': 782386,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 13.24,
        'windSpeed': 4.153,
        'maxWindSpeed': 7.4,
        'windDirection': 178.8,
        'soil12Data': {
          'moisture': 0.095,
          'temperature': 13.52
        },
        'soil30Data': {
          'moisture': 0.132,
          'temperature': 13.49
        },
        'elevatedData': {},
        'totalRainfall': 1455.5,
        'humidity': 69.19,
        'soilContactData': {
          'moisture': 34.14
        },
        'baroPressure': 972.9334,
        'solarRadiation': 89.42676,
        'soilContactFuelMoistureSecond': 21.93,
        'autoFuelMoistureStationId': 1,
        'createdOn': '2021-07-26T08:34:45.6962488Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 782386
      },
      'id': 1
    },
    {
      'stationCode': 'LORNE',
      'name': 'Lorne- Henderson Track',
      'mgrs': '54HYC5609130297',
      'latitude': -38.5389,
      'longitude': 143.93818,
      'latestDataId': 829001,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 14.75,
        'windSpeed': 1.893,
        'maxWindSpeed': 5.5,
        'windDirection': 195.1,
        'soil12Data': {
          'moisture': 0.104,
          'temperature': 14.81
        },
        'soil30Data': {
          'moisture': 0.185,
          'temperature': 14.84
        },
        'elevatedData': {},
        'totalRainfall': 1924.28,
        'humidity': 65.79,
        'soilContactData': {
          'moisture': 23.81
        },
        'baroPressure': 986.3666,
        'solarRadiation': 269.0429,
        'soilContactFuelMoistureSecond': 25.25,
        'autoFuelMoistureStationId': 2,
        'createdOn': '2021-07-26T10:08:23.8799862Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 829001
      },
      'id': 2
    },
    {
      'stationCode': 'ERICA',
      'name': 'Erica - Samson Track',
      'mgrs': '55HDT2765452889',
      'latitude': -38.36926,
      'longitude': 146.17183,
      'latestDataId': 822175,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 16.79,
        'windSpeed': 1.353,
        'maxWindSpeed': 8.2,
        'windDirection': 289.6,
        'soil12Data': {
          'moisture': 0.159,
          'temperature': 15.17
        },
        'soil30Data': {
          'moisture': 0.159,
          'temperature': 15.13
        },
        'elevatedData': {},
        'totalRainfall': 1480.82,
        'humidity': 53.33,
        'soilContactData': {
          'moisture': 52.68
        },
        'baroPressure': 989.3333,
        'solarRadiation': 276.1559,
        'soilContactFuelMoistureSecond': 42.33,
        'autoFuelMoistureStationId': 3,
        'createdOn': '2021-07-26T10:02:49.0663594Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 822175
      },
      'id': 3
    },
    {
      'stationCode': 'DARGO',
      'name': 'Dargo - Mt Thompson Track',
      'mgrs': '55HEU2013150794',
      'latitude': -37.48955,
      'longitude': 147.22772,
      'latestDataId': 814179,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 19.18,
        'windSpeed': 2.167,
        'maxWindSpeed': 3.4,
        'windDirection': 260.1,
        'soil12Data': {
          'moisture': 0.056,
          'temperature': 19.27
        },
        'soil30Data': {
          'moisture': 0.055,
          'temperature': 19.59
        },
        'elevatedData': {},
        'totalRainfall': 676.2,
        'humidity': 37.43,
        'soilContactData': {
          'moisture': 12.72
        },
        'baroPressure': 942.5,
        'solarRadiation': 1017.522,
        'soilContactFuelMoistureSecond': 11.95,
        'autoFuelMoistureStationId': 4,
        'createdOn': '2021-07-26T09:42:14.3252712Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 814179
      },
      'id': 4
    },
    {
      'stationCode': 'LOCHSPORT',
      'name': 'Loch Sport - Spoon Bay Track',
      'mgrs': '55HET4126183589',
      'latitude': -38.09456,
      'longitude': 147.47056,
      'latestDataId': 826901,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 21.03,
        'windSpeed': 3.907,
        'maxWindSpeed': 7.7,
        'windDirection': 297,
        'soil12Data': {
          'moisture': 0.011,
          'temperature': 21
        },
        'soil30Data': {
          'moisture': 0.084,
          'temperature': 21.6
        },
        'elevatedData': {},
        'totalRainfall': 567.74,
        'humidity': 41.15,
        'soilContactData': {
          'moisture': 7.974
        },
        'baroPressure': 1012.873,
        'solarRadiation': 618.6237,
        'soilContactFuelMoistureSecond': 8.07,
        'autoFuelMoistureStationId': 5,
        'createdOn': '2021-07-26T10:06:45.8037608Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 826901
      },
      'id': 5
    },
    {
      'stationCode': 'BENDOC',
      'name': 'Bendoc - Mt Bendoc',
      'mgrs': '55HFU7234886337',
      'latitude': -37.15349,
      'longitude': 148.94082,
      'latestDataId': 782784,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 14.03,
        'windSpeed': 3.987,
        'maxWindSpeed': 7,
        'windDirection': 251,
        'soil12Data': {
          'moisture': 0.1,
          'temperature': 13.45
        },
        'soil30Data': {
          'moisture': 0.167,
          'temperature': 13.7
        },
        'elevatedData': {},
        'totalRainfall': 813.21,
        'humidity': 55.35,
        'soilContactData': {
          'moisture': 19.09
        },
        'baroPressure': 911.4,
        'solarRadiation': 1024.252,
        'soilContactFuelMoistureSecond': 35.04,
        'autoFuelMoistureStationId': 6,
        'createdOn': '2021-07-26T08:35:44.8144371Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 782784
      },
      'id': 6
    },
    {
      'stationCode': 'CANNRV',
      'name': 'Cann River - Stafford Hill Track',
      'mgrs': '55HFU9940946948',
      'latitude': -37.50289,
      'longitude': 149.25594,
      'latestDataId': 810957,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2020-01-03T16:00:00.0000000Z',
        'dataType': 2,
        'airTemp': 20.48,
        'windSpeed': 3.14,
        'maxWindSpeed': 4.9,
        'windDirection': 3.401,
        'soil12Data': {
          'moisture': 0.055,
          'temperature': 17.76
        },
        'soil30Data': {
          'moisture': 0.132,
          'temperature': 17.59
        },
        'elevatedData': {},
        'totalRainfall': 227.83,
        'humidity': 67.7,
        'soilContactData': {
          'moisture': 11.82
        },
        'baroPressure': 969.42,
        'solarRadiation': -1.421367,
        'soilContactFuelMoistureSecond': 13.61,
        'autoFuelMoistureStationId': 7,
        'createdOn': '2021-07-26T09:35:26.3728649Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 810957
      },
      'id': 7
    },
    {
      'stationCode': 'BAIRNSDALE',
      'name': 'Bairnsdale - Faulkner Spur Track',
      'mgrs': '55HEU5058729465',
      'latitude': -37.68062,
      'longitude': 147.5737,
      'latestDataId': 789668,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2019-11-26T20:00:00.0000000Z',
        'dataType': 2,
        'airTemp': 8.27,
        'windSpeed': 1.727,
        'maxWindSpeed': 3.3,
        'windDirection': 299.7,
        'soil12Data': {
          'moisture': 0.079,
          'temperature': 13.17
        },
        'soil30Data': {
          'moisture': 0.168,
          'temperature': 13.15
        },
        'elevatedData': {},
        'totalRainfall': 158.09,
        'humidity': 69.7,
        'soilContactData': {
          'moisture': 43.67
        },
        'baroPressure': 987.2999,
        'solarRadiation': 88.60839,
        'soilContactFuelMoistureSecond': 38.19,
        'autoFuelMoistureStationId': 8,
        'createdOn': '2021-07-26T08:56:37.0632245Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 789668
      },
      'id': 8
    },
    {
      'stationCode': 'SWIFTSCK',
      'name': 'Swifts Creek - Splitters Range Rd',
      'mgrs': '55HEU6096488615',
      'latitude': -37.14686,
      'longitude': 147.68649,
      'latestDataId': 699008,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2020-05-18T21:00:00.0000000Z',
        'dataType': 2,
        'airTemp': 8.45,
        'windSpeed': 1.72,
        'maxWindSpeed': 3,
        'windDirection': 15.36,
        'soil12Data': {
          'moisture': 0.075,
          'temperature': 7.475
        },
        'soil30Data': {
          'moisture': 0.079,
          'temperature': 7.231
        },
        'elevatedData': {},
        'totalRainfall': 379.49,
        'humidity': 72.73,
        'soilContactData': {
          'moisture': 20.39
        },
        'baroPressure': 911.9334,
        'solarRadiation': -0.3033066,
        'soilContactFuelMoistureSecond': 19.45,
        'autoFuelMoistureStationId': 9,
        'createdOn': '2021-02-26T01:28:42.9400781Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 699008
      },
      'id': 9
    },
    {
      'stationCode': 'BEAUFORT',
      'name': 'Beaufort - Hell Hole Track',
      'mgrs': '54HXD9797973600',
      'latitude': -37.26314,
      'longitude': 143.23265,
      'latestDataId': 848739,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-09-06T23:00:00.0000000Z',
        'dataType': 2,
        'airTemp': 5.48,
        'windSpeed': 6.353,
        'maxWindSpeed': 11.8,
        'windDirection': 270.5,
        'soil12Data': {
          'moisture': 0.255,
          'temperature': 6.367
        },
        'soil30Data': {
          'moisture': 0.3,
          'temperature': 6.525
        },
        'elevatedData': {},
        'totalRainfall': 1287.05,
        'humidity': 92,
        'soilContactData': {
          'moisture': 62.78
        },
        'baroPressure': 936.82,
        'solarRadiation': 36.3272,
        'soilContactFuelMoistureSecond': 130,
        'autoFuelMoistureStationId': 10,
        'createdOn': '2021-09-06T23:01:26.2248091Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 848739
      },
      'id': 10
    },
    {
      'stationCode': 'HALLSGAP',
      'name': 'Halls Gap - Fields Track',
      'mgrs': '54HXD2512753578',
      'latitude': -37.4562,
      'longitude': 142.41476,
      'latestDataId': 824965,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 18.22,
        'windSpeed': 3.8,
        'maxWindSpeed': 7.5,
        'windDirection': 249.1,
        'soil12Data': {
          'moisture': 0.034,
          'temperature': 20.89
        },
        'soil30Data': {
          'moisture': 0.071,
          'temperature': 22.89
        },
        'elevatedData': {},
        'totalRainfall': 926.7,
        'humidity': 44.71,
        'soilContactData': {
          'moisture': 10.34
        },
        'baroPressure': 976.3066,
        'solarRadiation': 993.4019,
        'soilContactFuelMoistureSecond': 10.73,
        'autoFuelMoistureStationId': 11,
        'createdOn': '2021-07-26T10:05:02.3390050Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 824965
      },
      'id': 11
    },
    {
      'stationCode': 'MANSFIELD',
      'name': 'Mansfield - Kelly Creek Track',
      'mgrs': '55HDU3501939643',
      'latitude': -37.58798,
      'longitude': 146.26398,
      'latestDataId': 833774,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 14.88,
        'windSpeed': 3.347,
        'maxWindSpeed': 7.2,
        'windDirection': 206.7,
        'soil12Data': {
          'moisture': 0,
          'temperature': 33.05
        },
        'soil30Data': {
          'moisture': 0.225,
          'temperature': 15.62
        },
        'elevatedData': {},
        'totalRainfall': 2157.88,
        'humidity': 49.73,
        'soilContactData': {
          'moisture': 7.924
        },
        'baroPressure': 915.1399,
        'solarRadiation': 245.7114,
        'soilContactFuelMoistureSecond': 8.63,
        'autoFuelMoistureStationId': 12,
        'createdOn': '2021-07-26T10:18:21.5668590Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 833774
      },
      'id': 12
    },
    {
      'stationCode': 'ALEXANDRA',
      'name': 'Alexandra - Lookout Track',
      'mgrs': '55HDU1825956862',
      'latitude': -37.43146,
      'longitude': 146.07608,
      'latestDataId': 779221,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:00:00.0000000Z',
        'dataType': 2,
        'airTemp': 12.59,
        'windSpeed': 5.34,
        'maxWindSpeed': 9,
        'windDirection': 200.6,
        'soil12Data': {
          'moisture': 0.077,
          'temperature': 15.59
        },
        'soil30Data': {
          'moisture': 0.088,
          'temperature': 17.51
        },
        'elevatedData': {},
        'totalRainfall': 2374.11,
        'humidity': 56.99,
        'soilContactData': {
          'moisture': 12.87
        },
        'baroPressure': 909.3933,
        'solarRadiation': 231.0974,
        'soilContactFuelMoistureSecond': 7.428,
        'autoFuelMoistureStationId': 13,
        'createdOn': '2021-07-26T08:30:22.0079744Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 779221
      },
      'id': 13
    },
    {
      'stationCode': 'BRIGHT',
      'name': 'Bright - Tawonga Gap Track',
      'mgrs': '55HEV1086035766',
      'latitude': -36.72374,
      'longitude': 147.12162,
      'latestDataId': 847903,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-08-07T03:00:00.0000000Z',
        'dataType': 2,
        'airTemp': 6.18,
        'windSpeed': 1,
        'maxWindSpeed': 1.7,
        'windDirection': 218,
        'soil12Data': {
          'moisture': 0.013,
          'temperature': 8.39
        },
        'soil30Data': {
          'moisture': 0.253,
          'temperature': 6.768
        },
        'elevatedData': {},
        'totalRainfall': 1124.25,
        'humidity': 80.7,
        'soilContactData': {
          'moisture': 115
        },
        'baroPressure': 910.66,
        'solarRadiation': 140.0799,
        'soilContactFuelMoistureSecond': 69.06,
        'autoFuelMoistureStationId': 14,
        'createdOn': '2021-08-07T03:01:21.5652158Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 847903
      },
      'id': 14
    },
    {
      'stationCode': 'OVENS',
      'name': 'Ovens - Rose River Road',
      'mgrs': '55HDV5545822280',
      'latitude': -36.84433,
      'longitude': 146.50041,
      'latestDataId': 841580,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 21.31,
        'windSpeed': 3.053,
        'maxWindSpeed': 7.6,
        'windDirection': 6.855,
        'soil12Data': {
          'moisture': 0.07,
          'temperature': 19.28
        },
        'soil30Data': {
          'moisture': 0.087,
          'temperature': 20.47
        },
        'elevatedData': {},
        'totalRainfall': 1265.1,
        'humidity': 37.93,
        'soilContactData': {
          'moisture': 7.81
        },
        'baroPressure': 947.5934,
        'solarRadiation': 633.7919,
        'soilContactFuelMoistureSecond': 8.52,
        'autoFuelMoistureStationId': 15,
        'createdOn': '2021-07-26T10:32:22.9778598Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 841580
      },
      'id': 15
    },
    {
      'stationCode': 'CORRYONG',
      'name': 'Corryong -  Mt Elliot Ridge Track',
      'mgrs': '55HEV8838688464',
      'latitude': -36.24468,
      'longitude': 147.98371,
      'latestDataId': 35812,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2020-04-25T16:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 13.99,
        'windSpeed': 5.833,
        'maxWindSpeed': 8.6,
        'windDirection': 312.8,
        'soil12Data': {
          'moisture': 0.049,
          'temperature': 14.05
        },
        'soil30Data': {
          'moisture': 0.075,
          'temperature': 13.77
        },
        'elevatedData': {},
        'totalRainfall': 326.32,
        'humidity': 68.99,
        'soilContactData': {
          'moisture': 12.63
        },
        'baroPressure': 932.6799,
        'solarRadiation': -1.18922,
        'soilContactFuelMoistureSecond': 14.87,
        'autoFuelMoistureStationId': 16,
        'createdOn': '2020-04-25T07:14:48.5015088Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'updatedOn': '2021-07-26T09:36:57.8211465Z',
        'updatedBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 35812
      },
      'id': 16
    },
    {
      'stationCode': 'MITTA',
      'name': 'Mitta Valley - Dorchep Range Track',
      'mgrs': '55HEV2455059242',
      'latitude': -36.51186,
      'longitude': 147.27417,
      'latestDataId': 837054,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 18.32,
        'windSpeed': 2.86,
        'maxWindSpeed': 5.7,
        'windDirection': 339.6,
        'soil12Data': {
          'moisture': 0.186,
          'temperature': 16.25
        },
        'soil30Data': {
          'moisture': 0.162,
          'temperature': 16.4
        },
        'elevatedData': {},
        'totalRainfall': 2779.35,
        'humidity': 46.88,
        'soilContactData': {
          'moisture': 13.17
        },
        'baroPressure': 902.7333,
        'solarRadiation': 231.3535,
        'soilContactFuelMoistureSecond': 13.45,
        'autoFuelMoistureStationId': 17,
        'createdOn': '2021-07-26T10:24:49.4219181Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 837054
      },
      'id': 17
    },
    {
      'stationCode': 'FRENCHIS',
      'name': 'French Island - Mt Wellington Road',
      'mgrs': '55HCT5587352362',
      'latitude': -38.36533,
      'longitude': 145.35025,
      'latestDataId': 824201,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 19.12,
        'windSpeed': 2.14,
        'maxWindSpeed': 5.2,
        'windDirection': 215.6,
        'soil12Data': {
          'moisture': 0.065,
          'temperature': 16.08
        },
        'soil30Data': {
          'moisture': 0.053,
          'temperature': 16.04
        },
        'elevatedData': {},
        'totalRainfall': 839.96,
        'humidity': 43.65,
        'soilContactData': {
          'moisture': 34.67
        },
        'baroPressure': 1007.687,
        'solarRadiation': 315.189,
        'soilContactFuelMoistureSecond': 22.93,
        'autoFuelMoistureStationId': 18,
        'createdOn': '2021-07-26T10:04:02.2768373Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 824201
      },
      'id': 18
    },
    {
      'stationCode': 'OLINDA',
      'name': 'Olinda - Wallaby Track',
      'mgrs': '55HCU5847913361',
      'latitude': -37.81619,
      'longitude': 145.39215,
      'latestDataId': 838510,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 15.12,
        'windSpeed': 1.453,
        'maxWindSpeed': 4,
        'windDirection': 216.3,
        'soil12Data': {
          'moisture': 0.062,
          'temperature': 15.75
        },
        'soil30Data': {
          'moisture': 0.12,
          'temperature': 15.71
        },
        'elevatedData': {},
        'totalRainfall': 1414.9,
        'humidity': 55.25,
        'soilContactData': {
          'moisture': 14.52
        },
        'baroPressure': 973.0534,
        'solarRadiation': 133.4591,
        'soilContactFuelMoistureSecond': 16.15,
        'autoFuelMoistureStationId': 19,
        'createdOn': '2021-07-26T10:27:33.0640253Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 838510
      },
      'id': 19
    },
    {
      'stationCode': 'BENALLA',
      'name': 'Benalla - Madhouse Rd',
      'mgrs': '55HDV2909119917',
      'latitude': -36.86402,
      'longitude': 146.20448,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'id': 20
    },
    {
      'stationCode': 'HEYWOOD',
      'name': 'Heywood - Cut Out Dam Rd',
      'mgrs': '54HWC4253174767',
      'latitude': -38.17401,
      'longitude': 141.48557,
      'latestDataId': 825266,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 15.99,
        'windSpeed': 2.793,
        'maxWindSpeed': 4.5,
        'windDirection': 91,
        'soil12Data': {
          'moisture': 0.163,
          'temperature': 15.59
        },
        'soil30Data': {
          'moisture': 0.227,
          'temperature': 15.71
        },
        'elevatedData': {},
        'totalRainfall': 784.81,
        'humidity': 58.37,
        'soilContactData': {
          'moisture': 27.23
        },
        'baroPressure': 1005.52,
        'solarRadiation': 152.9882,
        'soilContactFuelMoistureSecond': 31.92,
        'autoFuelMoistureStationId': 21,
        'createdOn': '2021-07-26T10:05:46.0684639Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 825266
      },
      'id': 21
    },
    {
      'stationCode': 'MACEDON',
      'name': 'Macedon- Bawden Rd ',
      'mgrs': '55HBU8428959237',
      'latitude': -37.39058572,
      'longitude': 144.5621584,
      'latestDataId': 831828,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 14.31,
        'windSpeed': 8.19,
        'maxWindSpeed': 11.8,
        'windDirection': 175.5,
        'soil12Data': {
          'moisture': 0.13,
          'temperature': 14
        },
        'soil30Data': {
          'moisture': 0.132,
          'temperature': 14.25
        },
        'elevatedData': {},
        'totalRainfall': 983.56,
        'humidity': 54.56,
        'soilContactData': {
          'moisture': 13.47
        },
        'baroPressure': 939.2266,
        'solarRadiation': 244.7701,
        'soilContactFuelMoistureSecond': 15.6,
        'autoFuelMoistureStationId': 22,
        'createdOn': '2021-07-26T10:13:38.5640495Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 831828
      },
      'id': 22
    },
    {
      'stationCode': 'POWELLTOWN',
      'name': 'Powelltown - Road 15 Upper Yarra',
      'mgrs': '55HDU0875624000',
      'latitude': -37.72673,
      'longitude': 145.96459,
      'latestDataId': 844224,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 11.9,
        'windSpeed': 1.907,
        'maxWindSpeed': 4.8,
        'windDirection': 291.4,
        'soil12Data': {
          'moisture': 0.096,
          'temperature': 13.46
        },
        'soil30Data': {
          'moisture': 0.1,
          'temperature': 13.2
        },
        'elevatedData': {},
        'totalRainfall': 1789.09,
        'humidity': 69.38,
        'soilContactData': {
          'moisture': 41.73
        },
        'baroPressure': 928.6066,
        'solarRadiation': 97.14248,
        'soilContactFuelMoistureSecond': 91.4,
        'autoFuelMoistureStationId': 24,
        'createdOn': '2021-07-26T10:35:23.8834260Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 844224
      },
      'id': 24
    },
    {
      'stationCode': 'FMC1_FLUXTOWR',
      'name': 'Daylesford - Flux Tower',
      'mgrs': '55HBU429543',
      'latitude': -37.4225,
      'longitude': 144.0944,
      'latestDataId': 771983,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-05-26T11:00:00.0000000Z',
        'dataType': 1,
        'airTemp': 6.9,
        'windSpeed': 1.1,
        'maxWindSpeed': 3.4,
        'windDirection': 33.5,
        'soil12Data': {
          'moisture': 0
        },
        'elevatedData': {
          'moisture': 42,
          'temperature': 6
        },
        'totalRainfall': 0,
        'humidity': 70,
        'soilContactData': {
          'moisture': 71.3,
          'temperature': 5.9
        },
        'exposedFuelData': {
          'moisture': 142,
          'temperature': 6.3
        },
        'nearSurfaceData': {
          'moisture': 103,
          'temperature': 5.9
        },
        'dewPoint': 1.8,
        'baroPressure': 946.3,
        'autoFuelMoistureStationId': 25,
        'createdOn': '2021-05-30T03:32:57.6813646Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 771983
      },
      'id': 25
    },
    {
      'stationCode': 'FMC1_STRBRKTK',
      'name': 'St Arnaud - Stringybark',
      'mgrs': '54HYE037416',
      'latitude': -36.65,
      'longitude': 143.28,
      'latestDataId': 771981,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-05-30T01:00:00.0000000Z',
        'dataType': 1,
        'airTemp': 8.5,
        'windSpeed': 3.3,
        'maxWindSpeed': 8.3,
        'windDirection': 150.7,
        'soil12Data': {
          'moisture': 9
        },
        'elevatedData': {
          'moisture': 20.3,
          'temperature': 10.4
        },
        'totalRainfall': 0,
        'humidity': 66.3,
        'soilContactData': {
          'moisture': 21.2,
          'temperature': 14.2
        },
        'exposedFuelData': {
          'moisture': 19.4,
          'temperature': 10.9
        },
        'nearSurfaceData': {
          'moisture': 18.8,
          'temperature': -39.9
        },
        'dewPoint': 2.6,
        'baroPressure': 998.9,
        'autoFuelMoistureStationId': 26,
        'createdOn': '2021-05-30T03:27:55.3243404Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 771981
      },
      'id': 26
    },
    {
      'stationCode': 'FMC1_HATTAH',
      'name': 'Hattah - Hattah Depot',
      'mgrs': '54HXG2172152765',
      'latitude': -34.76,
      'longitude': 142.33,
      'latestDataId': 771913,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-05-29T21:30:00.0000000Z',
        'dataType': 1,
        'airTemp': -0.7,
        'windSpeed': 1.3,
        'maxWindSpeed': 2.6,
        'windDirection': 168.9,
        'soil12Data': {
          'moisture': 0
        },
        'elevatedData': {
          'moisture': 16,
          'temperature': -39.9
        },
        'totalRainfall': 0,
        'humidity': 89,
        'soilContactData': {
          'moisture': 18.3,
          'temperature': -39.9
        },
        'exposedFuelData': {
          'moisture': 16.5,
          'temperature': -3.5
        },
        'nearSurfaceData': {
          'moisture': -1.9,
          'temperature': -3.2
        },
        'dewPoint': -2.3,
        'baroPressure': 1022.7,
        'autoFuelMoistureStationId': 27,
        'createdOn': '2021-05-29T22:58:17.6995807Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 771913
      },
      'id': 27
    },
    {
      'stationCode': 'FMC1_CENTRTRK',
      'name': 'Dimboola - Centre Track',
      'mgrs': '54HWE7532761438',
      'latitude': -36.4894,
      'longitude': 141.841,
      'latestDataId': 814165,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2020-11-14T19:00:00.0000000Z',
        'dataType': 1,
        'airTemp': 16.5,
        'windSpeed': 5.7,
        'maxWindSpeed': 15.4,
        'windDirection': 36.9,
        'soil12Data': {
          'moisture': 2.4
        },
        'elevatedData': {
          'moisture': 11.5,
          'temperature': 15.2
        },
        'totalRainfall': 0,
        'humidity': 45.5,
        'soilContactData': {
          'moisture': 11.5,
          'temperature': 15.3
        },
        'exposedFuelData': {
          'moisture': 10.2,
          'temperature': 15
        },
        'nearSurfaceData': {
          'moisture': 11.9,
          'temperature': 15.6
        },
        'dewPoint': 4.7,
        'baroPressure': 987.1,
        'autoFuelMoistureStationId': 28,
        'createdOn': '2021-07-26T09:42:10.4575372Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 814165
      },
      'id': 28
    },
    {
      'stationCode': 'FMC1_TULLICH',
      'name': 'Casterton - Tullich',
      'mgrs': '54HWD2484339614',
      'latitude': -37.5902,
      'longitude': 141.2814,
      'latestDataId': 771953,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-05-29T17:30:00.0000000Z',
        'dataType': 1,
        'airTemp': 4.9,
        'windSpeed': 3.2,
        'maxWindSpeed': 7.4,
        'windDirection': 71,
        'soil12Data': {
          'moisture': 77.9
        },
        'elevatedData': {
          'moisture': 85.7,
          'temperature': 4.9
        },
        'totalRainfall': 0,
        'humidity': 90.6,
        'soilContactData': {
          'moisture': 29.3,
          'temperature': 6.3
        },
        'exposedFuelData': {
          'moisture': 61.1,
          'temperature': 99.9
        },
        'nearSurfaceData': {
          'moisture': 104,
          'temperature': 5.3
        },
        'dewPoint': 3.5,
        'baroPressure': 1014.2,
        'autoFuelMoistureStationId': 29,
        'createdOn': '2021-05-30T01:05:57.2595363Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 771953
      },
      'id': 29
    },
    {
      'stationCode': 'FMC1_BLACKRNG',
      'name': 'Alexandra - Black Range',
      'mgrs': '55HCU7469476480',
      'latitude': -37.2498,
      'longitude': 145.5871,
      'latestDataId': 793072,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-03-26T18:30:00.0000000Z',
        'dataType': 1,
        'airTemp': 2880,
        'windSpeed': 2155,
        'maxWindSpeed': 662,
        'windDirection': 0,
        'soil12Data': {
          'moisture': 0
        },
        'elevatedData': {
          'moisture': 0,
          'temperature': -39.9
        },
        'totalRainfall': 0,
        'humidity': 0,
        'soilContactData': {
          'moisture': 76.9,
          'temperature': -39.9
        },
        'exposedFuelData': {
          'moisture': 65.8,
          'temperature': 11.9
        },
        'nearSurfaceData': {
          'moisture': 50,
          'temperature': 11.8
        },
        'baroPressure': 2.8,
        'autoFuelMoistureStationId': 30,
        'createdOn': '2021-07-26T09:13:10.0632079Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 793072
      },
      'id': 30
    },
    {
      'stationCode': 'FMC1_HAPPYJAK',
      'name': 'Erica - Happy Jack',
      'mgrs': '55HDU4755200474',
      'latitude': -37.9418,
      'longitude': 146.4031,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'id': 31
    },
    {
      'stationCode': 'FMC1_BOXTRACK',
      'name': 'Bendigo - Box Tk',
      'mgrs': '55HBV7138032611',
      'latitude': -36.7247,
      'longitude': 144.44,
      'latestDataId': 771933,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-05-29T22:30:00.0000000Z',
        'dataType': 1,
        'airTemp': 0,
        'windSpeed': 0,
        'maxWindSpeed': 0,
        'windDirection': 0,
        'soil12Data': {
          'moisture': 0
        },
        'elevatedData': {
          'moisture': 16.7,
          'temperature': -39.9
        },
        'totalRainfall': 0,
        'humidity': 89.2,
        'soilContactData': {
          'moisture': 26.8,
          'temperature': -39.9
        },
        'exposedFuelData': {
          'moisture': 36,
          'temperature': 0.5
        },
        'nearSurfaceData': {
          'moisture': 27.2,
          'temperature': 0
        },
        'dewPoint': -1.7,
        'baroPressure': 1004.7,
        'autoFuelMoistureStationId': 32,
        'createdOn': '2021-05-30T00:09:05.1937234Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 771933
      },
      'id': 32
    },
    {
      'stationCode': 'SMYTHESDALE',
      'name': 'Smythesdale - Hillcrest Road',
      'mgrs': '54HYD3415630410',
      'latitude': -37.64363,
      'longitude': 143.65398,
      'latestDataId': 846110,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 16.31,
        'windSpeed': 2.507,
        'maxWindSpeed': 7.2,
        'windDirection': 178.7,
        'soil12Data': {
          'moisture': 0.052,
          'temperature': 16.19
        },
        'soil30Data': {
          'moisture': 0.136,
          'temperature': 16.13
        },
        'elevatedData': {},
        'totalRainfall': 567.3,
        'humidity': 48.73,
        'soilContactData': {
          'moisture': 14.7
        },
        'baroPressure': 971.8534,
        'solarRadiation': 96.51915,
        'soilContactFuelMoistureSecond': 14.02,
        'autoFuelMoistureStationId': 33,
        'createdOn': '2021-07-26T10:39:52.9098267Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 846110
      },
      'id': 33
    },
    {
      'stationCode': 'FAKE',
      'name': 'This Test Data',
      'mgrs': 'DS 440 886',
      'latitude': -38.949516,
      'longitude': 146.35437,
      'latestDataId': 846110,
      'fromDate': '0001-01-01T00:00:00.0000000Z',
      'latestData': {
        'dateTime': '2021-02-26T01:30:00.0000000Z',
        'dataType': 2,
        'airTemp': 16.31,
        'windSpeed': 2.507,
        'maxWindSpeed': 7.2,
        'windDirection': 178.7,
        'soil12Data': {
          'moisture': 0.052,
          'temperature': 16.19
        },
        'soil30Data': {
          'moisture': 0.136,
          'temperature': 16.13
        },
        'elevatedData': {},
        'totalRainfall': 567.3,
        'humidity': 48.73,
        'soilContactData': {
          'moisture': 14.7
        },
        'baroPressure': 971.8534,
        'solarRadiation': 96.51915,
        'soilContactFuelMoistureSecond': 14.02,
        'autoFuelMoistureStationId': 33,
        'createdOn': '2021-07-26T10:39:52.9098267Z',
        'createdBy': 'service-account-portal-fuel-monitoring-service@placeholder.org',
        'id': 846110
      },
      'id': 34
    }
  ];
};


// WEBPACK FOOTER //
// ./src/actions/populate_fms_data.js